import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { CasesGeneralInformationFilters } from './filters';
import { CasesGeneralInformationList } from './list';
import { CasesGeneralInformationFilter } from '../../../../shared/types/modules/cases-general-information';

export const CasesGeneralInformation = () => {
    const [filters, setFilters] = useState<CasesGeneralInformationFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de casos información general">
                <CasesGeneralInformationFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <CasesGeneralInformationList filters={filters} />
        </>
    );
};
